export const validateOrganization = (organization) => {
    if (!organization || organization === "0" || !(organization.length >= 1 && organization.length <= 50))
        return 'Please select an organization from the provided list.';

    return '';
}